/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TabsChatActivities_Query = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"BadgeChatActivityUnassigned_Viewer">;
    } | null;
    readonly " $refType": "TabsChatActivities_Query";
};
export type TabsChatActivities_Query$data = TabsChatActivities_Query;
export type TabsChatActivities_Query$key = {
    readonly " $data"?: TabsChatActivities_Query$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TabsChatActivities_Query">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TabsChatActivities_Query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BadgeChatActivityUnassigned_Viewer"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
(node as any).hash = 'a07e220b90ab59ae14f29034f2ca21a5';
export default node;
